import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskGettingStartedRoute: InvariantJiraRoute = {
	name: 'servicedesk-getting-started-page',
	path: '/jira/servicedesk/projects/:projectKey/getting-started',
	exact: true,
};
